var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3555 0H3.14767C1.74409 0 0.608463 1.11843 0.608463 2.48539L0.595703 22.3685C0.595703 23.7355 1.73133 24.8539 3.13491 24.8539H18.4595C19.863 24.8539 21.0114 23.7355 21.0114 22.3685V7.45618L13.3555 0ZM15.9075 19.8831H5.69964V17.3978H15.9075V19.8831ZM15.9075 14.9124H5.69964V12.427H15.9075V14.9124ZM12.0796 8.69888V1.86404L19.0975 8.69888H12.0796Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.daa68c1eb27a753f886281e3e12b3961.svg";
export { ForwardRef as ReactComponent };